import { ITaskRule } from '@common/interfaces/taskRule'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

// The open Rules modal's list. Refetched after each mutation, like the project custom fields.
const rulesData = createLoadingDataReducer<ITaskRule[] | null>(
  [actions.LIST_TASK_RULES_REQUEST],
  [
    actions.CREATE_TASK_RULE_REQUEST,
    actions.UPDATE_TASK_RULE_REQUEST,
    actions.DELETE_TASK_RULE_REQUEST,
  ],
  false,
  [actions.RESET_TASK_RULES],
)

export default combineReducers({
  rulesData,
})
